import React from 'react'
import { Checkbox, Form } from 'semantic-ui-react'

import type { ActionGroup } from '..'

export default function ActionGroupForm({
  actionGroups,
  handlePermissionChange,
  isDisabled,
}: ActionGroupFormProps) {
  function deselectChildrenActions(action) {
    const childrenActions = action?.children_actions || []
    childrenActions.forEach((actionName) => {
      handlePermissionChange(['permissions', actionName], false)
    })
  }

  return actionGroups.map((actionGroup) => (
    <Form.Group grouped key={actionGroup.group}>
      <label>{actionGroup.group}</label>
      {actionGroup.actions.map((action) => (
        <Form.Field key={action.name}>
          <Checkbox
            name={action.name}
            label={{
              children: <div>{action.label}</div>,
            }}
            checked={Boolean(action.value)}
            disabled={isDisabled}
            onChange={(_, { checked }) => {
              handlePermissionChange(['permissions', action.name], checked)

              if (checked === false) {
                deselectChildrenActions(action)
              }
            }}
          />
        </Form.Field>
      ))}
    </Form.Group>
  ))
}

interface ActionGroupFormProps {
  actionGroups: ActionGroup[]
  handlePermissionChange: (paths: any[], value: any) => void
  isDisabled: boolean
}



// WEBPACK FOOTER //
// ./src/components/CustomRoleForm/components/ActionGroupForm.tsx